import { extendTheme } from "@chakra-ui/react"
export const theme = extendTheme({
    colors:{
        primary:{
            100:"#EBE6F2",
            200:"#CEBEDF",
            300:"#9377AF",
            400:"#604080",
            500:"#331551",
            600:"#290d44",
            700:"#200638",
            800:"#1e013a",
            900:"#0f011d"
        },
        secondary:{
            100:"#FAEDE1",
            200:"#FAD3AF",
            300:"#F8B270",
            400:"#F89337",
            500:"#e27b1a",
            600:"#EC8200",
            700:"#b65b06",
            800:"#5c3301",
            900:"#3a2300"
        }, 
        tertiary: {
            50:"#fae5e5",
            100:"#f1cfcf",
            200:"#f5bdbd",
            300:"#dd8484",
            400:"#c74141",
            500:"#BF3130",
            600:"#971818",
            700:"#7a0707",
            800:"#5a0101",
            900:"#290000",
        }
    },
})